import Grid from '../../../share/grid/Grid.vue'
import Page from '../../../../share/content/Page'
import NewBankModal from './modal/NewBank.vue'
import ActionButton from '@/components/bundles/share/grid/ActionButton'

export default {
  template: `
    <div>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="box box-default box-solid">
                        <div class="box-body table-responsive">
                            <grid :source="gridDataSource"
                                  :name="gridName"
                                  :columns="gridColumns"
                                  :actions="gridActions"
                                  :defaultOrder="[[1, 'asc']]"
                                  @show="actionShow">
                            </grid>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <new-bank-modal :show="modalBankVisible"
                    @close="modalBankVisible = false"
                    mode="new"
                    :service="service">
        </new-bank-modal>
    </div>`,
  components: {
    Grid,
    NewBankModal
  },
  mixins: [
    Page
  ],
  data () {
    return {
      events: {
        addBank: 'core:bank:addBank'
      },
      gridActions: [
        { id: 0, event: 'show', title: 'Szczegóły', icon: 'folder-open', acl: { service: 'core', action: 'get_bank' } }
      ],
      modalBankVisible: false
    }
  },
  mounted () {
    this.$events.on(this.events.addBank, this.addBank)
  },
  computed: {
    gridDataSource () {
      const vm = this
      return { service: vm.service, url: '/bank' }
    },
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: (data, type, row) => {
            return ActionButton.renderActionButtons(data, type, row, this.gridActions, this)
          }
        },
        { id: 1, data: 'label', title: 'Nazwa' },
        { id: 2, data: 'city', title: 'Miejscowość' },
        { id: 3, data: 'postcode', title: 'Kod pocztowy' },
        { id: 4, data: 'voivodeship', title: 'Województwo' }
      ]
    }
  },
  methods: {
    addBank () {
      this.modalBankVisible = true
    },
    actionShow (id) {
      const vm = this
      this.$router.push({ name: vm.actionShowUrlName, params: { id } })
    }
  }
}
